import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ViewWorkDataQuestion, QuestionTypeEnum } from 'src/app/Elearning-Models';
import { FilterQuestionsService } from 'src/app/Services/filter-questions.service';
import { areAllEquivalent } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-multiple-choice',
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.scss']
})
export class MultipleChoiceComponent implements OnInit {
  @Input() question: ViewWorkDataQuestion;
  @Input() isConsumerCurriculum: boolean;
  @Output() gradeChanges: EventEmitter<any> = new EventEmitter<any>();

  filterSubscription: Subscription;
  filterValue: string;

  correct: boolean = false;

  responseFormGroup = new FormGroup({
    studentResponse: new FormControl({value: null, disabled: true})
  });

  constructor(
    private filterQuestionsService: FilterQuestionsService
  ) { }

  ngOnInit(): void {
    this.filterSubscription = this.filterQuestionsService.currentFilterValue.subscribe(
      (filterValue) => {
        this.filterValue = filterValue;
      }
    );
    this.setStudentAnswer();
    this.checkStudentAnswer();
  }

  checkStudentAnswer(){
    if(this.question.StudentResponse.length == 1)
    {
      if(this.question.QuestionTypeEnumValue == QuestionTypeEnum.MultipleChoice){
        var i = parseInt(this.question.StudentResponse[0]);
        this.correct = this.question.AvailableResponses[i].IsCorrect;
      }
      else{
        var answer = this.question.StudentResponse[0]; 
        this.correct = this.question.AvailableResponses[0].Response == answer;
      }
    }
    else{
      this.correct = false;
    }
  }

  setStudentAnswer(){
    var response = this.question.StudentResponse;
    if(response.length == 1){
        this.SetStudentAnswers(response[0]);
      }
  }

  SetStudentAnswers(str : string){
    if(str !== null && str !== "") {
      if(this.question.QuestionTypeEnumValue === 2) {
        this.responseFormGroup.controls['studentResponse'].setValue(str);
      } else {
        this.responseFormGroup.controls['studentResponse'].setValue(+str);
      }
    }
  }

  gradeStatusChanged = (gradeFormValue) => {
    this.filterValue='';
    switch (gradeFormValue.grade) {
      case "notGraded" : {
        this.question.PointsEarned = null;
        this.correct = false;
        break;
      }
      case "incorrect" : {
        this.question.PointsEarned = 0;
        this.correct = false;
        break;
      }
      case "correct" : {
        this.question.PointsEarned = this.question.PointsAvailable;
        this.correct = true;
        break;
      }
      case "partialCredit" : {
        this.question.PointsEarned = gradeFormValue.partialCredit;
        break;
      }
    }

    this.gradeChanges.emit(this.question);
  }

  partialCreditChanged = (partialCredit) => {
    this.filterValue='';
    this.question.PointsEarned = partialCredit;
    this.gradeChanges.emit(this.question);
  }
}
